export const Headers = {
    // 'X-Mashape-Key': 'required',
    'Content-Type': 'application/json',
    'Accept': 'application/json'
}
export const FormHeaders = {
    'Content-Type': 'multipart/form-data',
}